import { UserRole } from 'types/User';

/**
 * @deprecated use CommentThread instead
 */
export enum CommentType {
  Internal = 1,
  Client = 2,
}

/**
 * @deprecated use CommentThread instead
 */
export enum PostCommentTaskType {
  Default = 0,
  Approval = 1,
  Assigning = 2,
  Done = 3,
  Scheduled = 4,
}

export const ALLOWED_ROLES_TO_MENTION_IN_INTERNAL_COMMENTS: UserRole[] = [
  'admin',
  'manager',
  'translator',
  'artist',
];

export const ALLOWED_ROLES_TO_MENTION_IN_CLIENT_COMMENTS: UserRole[] = [
  'client',
  'admin',
  'manager',
];
